/**
 * API Configuration
 * Central configuration for all API endpoints
 */

// NOC API Base URL
export const NOC_API_BASE_URL = 'https://a8jboiv7a5.execute-api.us-east-1.amazonaws.com';

// FAQ API Base URL (existing)
export const FAQ_API_BASE_URL = process.env.REACT_APP_FAQ_API_URL || 'https://your-faq-api-gateway-url.amazonaws.com';

// NOC API Endpoints
export const NOC_API_ENDPOINTS = {
  metrics: `${NOC_API_BASE_URL}/noc/metrics`,
  events: `${NOC_API_BASE_URL}/noc/events`,
  alerts: `${NOC_API_BASE_URL}/noc/alerts`,
  alertDetails: (alertId: string) => `${NOC_API_BASE_URL}/noc/alerts/${alertId}`,
  updateAlert: (alertId: string) => `${NOC_API_BASE_URL}/noc/alerts/${alertId}`,
  userProfile: (userId: string) => `${NOC_API_BASE_URL}/noc/users/${userId}`,
  blockUser: (userId: string) => `${NOC_API_BASE_URL}/noc/users/${userId}/block`,
  unblockUser: (userId: string) => `${NOC_API_BASE_URL}/noc/users/${userId}/unblock`,
};

// Analytics API Endpoints
export const ANALYTICS_API_ENDPOINTS = {
  query: `${NOC_API_BASE_URL}/analytics/query`,
  assess: `${NOC_API_BASE_URL}/analytics/assess`,
  dashboard: (timeRange: { year: string; month: string; day: string }) =>
    `${NOC_API_BASE_URL}/analytics/dashboard?year=${timeRange.year}&month=${timeRange.month}&day=${timeRange.day || ''}`,
  queryStatus: (queryId: string) => `${NOC_API_BASE_URL}/analytics/query/${queryId}`,
};

// Session management
export const getOrCreateSessionId = (): string => {
  let sessionId = localStorage.getItem('faq_session_id');

  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    localStorage.setItem('faq_session_id', sessionId);
  }

  return sessionId;
};

// API helper functions
export const nocApiRequest = async (
  url: string,
  options: RequestInit = {}
): Promise<any> => {
  try {
    const response = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

    if (!response.ok) {
      throw new Error(`API request failed: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error('NOC API request error:', error);
    throw error;
  }
};

export const analyticsApiRequest = async (
  url: string,
  options: RequestInit = {}
): Promise<any> => {
  try {
    const response = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

    if (!response.ok) {
      throw new Error(`Analytics API request failed: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Analytics API request error:', error);
    throw error;
  }
};
